import { render, staticRenderFns } from "./mydeal.vue?vue&type=template&id=54a6deda&scoped=true"
import script from "./mydeal.vue?vue&type=script&lang=js"
export * from "./mydeal.vue?vue&type=script&lang=js"
import style0 from "./mydeal.vue?vue&type=style&index=0&id=54a6deda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6deda",
  null
  
)

export default component.exports